import React from 'react';
import { UserIcon as User } from './Icons';

const DashboardPageHeader = ({ 
    title, 
    description, 
    image, 
    fallbackIcon: Icon = User, 
    actions,
    backButton
}) => {
    return (
        <header className="mb-10 flex flex-col sm:flex-row items-center gap-6 sm:gap-8 animate-fade-in px-2">
            <div className="flex flex-col sm:flex-row items-center gap-6 sm:gap-8 flex-1 min-w-0">
                {backButton && (
                    <div className="shrink-0">
                        {backButton}
                    </div>
                )}
                
                <div className="relative group shrink-0">
                    <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-[2rem] bg-secondary-container flex items-center justify-center text-secondary shadow-elevation-1 group-hover:scale-105 transition-transform duration-emphasized overflow-hidden">
                        {image ? (
                            <img
                                src={image}
                                alt={title}
                                className="w-full h-full object-cover rounded-[2rem]"
                            />
                        ) : (
                            <Icon size={48} className="opacity-80" />
                        )}
                    </div>
                </div>

                <div className="text-center sm:text-left min-w-0">
                    <h1 className="text-display-small font-bold text-surface-on mb-2 truncate">
                        {title}
                    </h1>
                    {description && (
                        <p className="text-title-medium text-surface-onVariant opacity-80 max-w-md">
                            {description}
                        </p>
                    )}
                </div>
            </div>

            {actions && (
                <div className="flex items-center gap-2 shrink-0">
                    {actions}
                </div>
            )}
        </header>
    );
};

export default DashboardPageHeader;
